<template>
  <div>
    <Editor id="tinymce" v-model="tinymceHtml" :init="tinymceData"></Editor>
  </div>
</template>

<script>
import 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import { getApiKey } from '@/utils/apiKey'

import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
// import 'tinymce/plugins/autolink'
import 'tinymce/plugins/table'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/code'
import 'tinymce/plugins/fullscreen'
// import 'tinymce/plugins/insertdatetime'
// import 'tinymce/plugins/template'
// import 'tinymce/plugins/paste'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/print'
//import 'tinymce/plugins/indent2em/plugin'
//import 'tinymce/plugins/lineheight/plugin'
import '@/../public/tinymce/plugins/indent2em/plugin'
import '@/../public/tinymce/plugins/lineheight/plugin'
import 'tinymce/icons/default/icons.min.js'

export default {
  components: {
    Editor
  },
  props:{
    plugins:{
      type: String,
      //default:'link lists image table colorpicker textcolor wordcount ',
      default:'link lists image media table textcolor wordcount contextmenu hr preview fullscreen anchor code indent2em lineheight',
    },
    toolbar:{
      type: String,
      //default: 'undo redo | bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | table link unlink image | removeformat',
      default: 'undo redo paste | bold italic underline strikethrough | fontselect fontsizeselect | indent2em lineheight | forecolor backcolor | ltr rtl | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | link unlink image media table | removeformat anchor hr | code preview fullscreen',
    },
    showMenu:{
      type: Boolean,
      default: true
    },
    editorHeight: {
      type: Number,
      default: 300,
    },
    initHtml:{
      type: String,
      default: ''
    },
    fontFormats: {
      type: String,
      default: '宋体=simsun,serif;仿宋体=FangSong,serif;楷体=KaiTi,serif;黑体=SimHei,sans-serif;微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Verdana=verdana,geneva;'
    }
  },
  data() {
    return {
      tinymceHtml: '',
      tinymceData: {
        language_url: '/tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide',
        images_upload_url: '/service/upload/image',
        methods: "POST",
        height: this.editorHeight,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: this.showMenu,
        images_upload_handler: this.imagesUploadHandler,
        convert_urls:false,
        font_formats: this.fontFormats,
        toolbar_drawer: false
      }
    }
  },
  created(){
  },
  computed: {
  },
  watch: {
    // 初始化编辑器内容
    "initHtml": function(val) {
      this.tinymceHtml = val
    },
    // 处理编辑器内容变化
    "tinymceHtml" : function(val) {
      this.$emit('handleTinymceInput',val)
    }
  },
  methods: {
    imagesUploadHandler(blobInfo, success, failure){
      let url = this.tinymceData.images_upload_url
      let formData = new FormData()
      formData.append('file', blobInfo.blob(), blobInfo.filename())
      // 添加请求头
      const headers = {
        'x-api-key': getApiKey(),
        'Authorization': localStorage.getItem("Authorization")
      };
        this.$api.post(url, formData, { headers }).then((res)=>{
          if (this.$apiSuccess(res)){
            if(res.data.startsWith("http")){
              success(res.data)
            }else if(res.data.startsWith("/")){
              success(window.location.origin + res.data)
            }else{
              success(window.location.origin + "/" + res.data)
            }
          }else{
            failure('上传失败')
          }
        }).catch(()=>{
          failure('上传失败')
        })
    }
  }
}
</script>
